import { render } from "./CookieConsent.vue?vue&type=template&id=419697a6&scoped=true"
import script from "./CookieConsent.ts?vue&type=script&lang=js"
export * from "./CookieConsent.ts?vue&type=script&lang=js"

import "./CookieConsent.vue?vue&type=style&index=0&id=419697a6&lang=scss&scoped=true"

import exportComponent from "/Users/lucatescari/Documents/Projects/Private/rt-songpage/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-419697a6"]])

export default __exports__